export const isResponseSuccess = (status: string) => status === 'ok'
